import React, {useEffect} from "react";
import {ComponentPropsFromRoute} from "../../routers/routers";
import {RouteButtons} from "../common/route-tabs/route.buttons";
import {useTranslate} from "../../hooks/translate.hook";
import {useLocation} from "react-router-dom";
import {useNavigate} from "react-router";
import {Space, Typography} from "antd";
//import {useTranslate} from "../../hooks/translate.hook";

export const Property: React.FC<ComponentPropsFromRoute> = ({routeChildren}) => {


    const t = useTranslate();

    return (
        <Space direction={"vertical"} size={[30, 30]}>
            <Typography.Title level={3} style={{margin: 0}}>
                {t("PROPERTY.MAIN.TITLE")}
            </Typography.Title>

            <RouteButtons routes={routeChildren!} />
        </Space>
    )
}